// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__2NuRG","modalForm":"UpgradeEpcsModal_modalForm__2kK0K","modalFooter":"UpgradeEpcsModal_modalFooter__A03Tg"};